import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for pending payment prizes.
 * @extends JetView
 */
export default class tablePremiosPendientesPagarView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        // Return the layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'treetable', // Unique identifier for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    by: 'Currency', // Grouping by currency
                                    footer: {
                                        NoTicket: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                                        ValueBet: ['ValueBet', 'sum'], // Sum of ValueBet for footer
                                        ValuePrize: ['ValuePrize', 'sum'], // Sum of ValuePrize for footer
                                    },
                                    map: {
                                        ValueBet: ['ValueBet', 'sum'], // Mapping for ValueBet
                                        ValuePrize: ['ValuePrize', 'sum'], // Mapping for ValuePrize
                                    },
                                },
                            },
                            bready: function () {
                                this.openAll(); // Expand all rows on ready
                            },
                            footer: true, // Enable footer
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 410 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'NoTicket', // Column ID for ticket number
                                    header: 'No. Ticket', // Column header
                                    width: 150, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Return group template with value
                                            );
                                        return obj.NoTicket; // Return ticket number
                                    },
                                    footer: 'Total:', // Footer label
                                },
                                {
                                    id: 'CreationDate', // Column ID for creation date
                                    header: _('Fecha Creación'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'CreationTime', // Column ID for creation time
                                    header: _('Hora de creación'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'DatePrize', // Column ID for prize date
                                    header: _('Fecha Premio'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'TimePrize', // Column ID for prize time
                                    header: _('Hora Premio'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'ValueBet', // Column ID for bet value
                                    header: _('Valor Apostado'), // Localized header
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                                {
                                    id: 'ValuePrize', // Column ID for prize value
                                    header: _('Valor Premio'), // Localized header
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Currency', // Column ID for currency
                                    header: _('Moneda'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'PointSale', // Column ID for point of sale
                                    header: _('Punto de Venta'), // Localized header
                                    width: 250, // Column width
                                },
                                {
                                    id: 'ExpiredDate', // Column ID for expiration date
                                    header: _('Fecha Caducidad Pago'), // Localized header
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Expired', // Column ID for expired status
                                    header: _('Caduco'), // Localized header
                                    width: 150, // Column width
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay before data load
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        // Show no data overlay
                                        _("<div style='margin:75px; font-size:18px;'>No hay datos</div>"),
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        grid = $$('treetable'); // Get the tree table instance
        var url =
            devConfig.geturlApi() + // Construct API URL
            'es/Report/GetPremiosPendientes?Partner=' +
            id_partner +
            '&';
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'premiosPendientesPagar:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
